var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalancevector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11726_3602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32878 3.84395C0.960589 3.84395 0.662109 3.54549 0.662109 3.17729C0.662109 2.93902 0.787103 2.72995 0.975089 2.61207L2.76684 0.820321C3.02718 0.559974 3.4493 0.559974 3.70964 0.820321C3.97 1.08067 3.97 1.50278 3.70964 1.76313L2.96216 2.51062L7.99548 2.51061C8.36361 2.51061 8.66214 2.80909 8.66214 3.17729C8.66214 3.54549 8.36361 3.84395 7.99548 3.84395H1.36174C1.35566 3.84402 1.34958 3.84402 1.3435 3.84395H1.32878Z",
    fill: "#8E969C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6712 5.15606C11.0394 5.15606 11.3379 5.45452 11.3379 5.82272C11.3379 6.06099 11.2129 6.27006 11.0249 6.38792L9.23319 8.17966C8.97279 8.44006 8.55072 8.44006 8.29032 8.17966C8.02999 7.91932 8.02999 7.49719 8.29032 7.23686L9.03786 6.48939H4.00456C3.63636 6.48939 3.33789 6.19092 3.33789 5.82272C3.33789 5.45452 3.63636 5.15606 4.00456 5.15606H10.6383C10.6443 5.15599 10.6504 5.15599 10.6565 5.15606H10.6712Z",
    fill: "#8E969C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11726_3602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancevector);
export default __webpack_public_path__ + "static/media/balancevector.951b2852e1c2392fd820b933c8cfd9fb.svg";
export { ForwardRef as ReactComponent };